import { render } from "./ThirdPartyApps.vue?vue&type=template&id=1ff960a4&scoped=true"
import script from "./ThirdPartyApps.vue?vue&type=script&lang=js"
export * from "./ThirdPartyApps.vue?vue&type=script&lang=js"

import "./ThirdPartyApps.vue?vue&type=style&index=0&id=1ff960a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff960a4"]])

export default __exports__